import React, {
    useMemo,
} from 'react'
import LongTermLeaseFeesRequests from 'app/requests/ContractBasis/LongTermLeaseFees.requests'
import {
    LongTermLeaseFeeStatus,
} from 'app/enums/label.enums'

import LongTermLeaseFeesForm from '../LongTermLeaseFeesForm'
import {
    LongTermLeaseFeeObject,
} from '../LongTermLeaseFees.types'

export default function LongTermLeaseFeesCreate({
    onSuccess,
    onCancel,
}: {
    onSuccess: (el: { id: number }) => void,
    onCancel: () => void,
}) {
    const requestParams = useMemo(() => {
        return LongTermLeaseFeesRequests.create()
    }, [])

    return (
        <LongTermLeaseFeesForm
            value={{
                longTermLeaseFeesStatus: LongTermLeaseFeeStatus.IN_PROGRESS,
            } as LongTermLeaseFeeObject}
            onSuccess={onSuccess}
            onCancel={onCancel}
            requestParams={requestParams}
        />
    )
}
